module.exports = __webpack_public_path__ + "img/icon_zahnarzt_zweite_meinung.b81033a5.svg";